import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { toast } from 'react-toastify';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { Button, MenuItem } from '@material-ui/core';
import config from "../../lib/config";
import { calculateAge } from '../../utils/calculateAge';

const initialFormValue = {
    sex: "",
};

// STATIC DATA - Replace API calls with this
const STATIC_PROFILES = [
    {
        _id: "profile001",
        userid: "KS001",
        mname: "Rajesh Kumar",
        sex: "Male",
        year: 1995,
        date: "15",
        month: "06",
        castename: "Brahmin",
        subcaste: "Iyer",
        educ: "B.Tech Computer Science",
        occup: "Software Engineer",
        height: "5'10\"",
        city: "Bangalore",
        photopath: [], // Empty array will show default avatar
        email: "rajesh@ksmagent.com"
    },
    {
        _id: "profile002",
        userid: "KS002",
        mname: "Priya Sharma",
        sex: "Female",
        year: 1997,
        date: "22",
        month: "08",
        castename: "Kshatriya",
        subcaste: "Rajput",
        educ: "MBA Finance",
        occup: "Financial Analyst",
        height: "5'5\"",
        city: "Mumbai",
        photopath: [],
        email: "priya@ksmagent.com"
    },
    {
        _id: "profile003",
        userid: "KS003",
        mname: "Arun Patel",
        sex: "Male",
        year: 1993,
        date: "10",
        month: "12",
        castename: "Patel",
        subcaste: "Leuva Patel",
        educ: "CA (Chartered Accountant)",
        occup: "Senior Accountant",
        height: "5'8\"",
        city: "Ahmedabad",
        photopath: [],
        email: "arun@ksmagent.com"
    },
    {
        _id: "profile004",
        userid: "KS004",
        mname: "Sneha Reddy",
        sex: "Female",
        year: 1996,
        date: "05",
        month: "03",
        castename: "Reddy",
        subcaste: "Kapu",
        educ: "MBBS",
        occup: "Doctor",
        height: "5'4\"",
        city: "Hyderabad",
        photopath: [],
        email: "snehareddy@ksmagent.com"
    },
    {
        _id: "profile005",
        userid: "KS005",
        mname: "Vikram Singh",
        sex: "Male",
        year: 1994,
        date: "18",
        month: "09",
        castename: "Jat",
        subcaste: "Jat",
        educ: "B.Com",
        occup: "Business Owner",
        height: "6'0\"",
        city: "Delhi",
        photopath: [],
        email: "vikram@ksmagent.com"
    }
];

const STATIC_SAVED_PROFILES = ["profile002", "profile004"]; // IDs of saved profiles

function AgentsList() {
    const navigate = useNavigate();
    const [registerfilter, setRegisterfilters] = useState([]);
    const [formValue, setFormValue] = useState(initialFormValue);
    const [width, setWidth] = useState(window.innerWidth);
    const [height1, setHeight] = useState(window.innerHeight);

    const sexch = [
        { title: "Male", value: "Male" },
        { title: "Female", value: "Female" },
    ];

    const search = useLocation().search;
    const [searchparamsf, setsearchparamsf] = useState(search);

    // Parse search parameters (keeping your original filter logic)
    var filterobj = "status=1";
    const castename = new URLSearchParams(search).get('castename');
    if (castename) {
        filterobj += "&castename=" + castename;
    }
    const religion = new URLSearchParams(search).get('religion');
    if (religion) {
        filterobj += "&religion=" + religion;
    }
    const subcaste = new URLSearchParams(search).get('subcaste');
    if (subcaste) {
        filterobj += "&subcaste=" + subcaste;
    }
    const sex = new URLSearchParams(search).get('sex');
    if (sex) {
        filterobj += "&sex=" + sex;
    }
    const maritalname = new URLSearchParams(search).get('maritalname');
    if (maritalname) {
        filterobj += "&maritalname=" + maritalname;
    }

    const c_date = new Date();
    let year = c_date.getFullYear();
    const age1 = new URLSearchParams(search).get('age1');
    const age2 = new URLSearchParams(search).get('age2');

    const [castes, setCastes] = useState([]);

    // MODIFIED: Use static data instead of API call
    const getUserData = async () => {
        // Simulate API delay (optional)
        await new Promise(resolve => setTimeout(resolve, 300));

        // Apply filters to static data
        let filteredProfiles = [...STATIC_PROFILES];

        if (sex) {
            filteredProfiles = filteredProfiles.filter(p => p.sex === sex);
        }
        if (castename) {
            filteredProfiles = filteredProfiles.filter(p => p.castename === castename);
        }
        if (subcaste) {
            filteredProfiles = filteredProfiles.filter(p => p.subcaste === subcaste);
        }
        if (age1) {
            const g_year = year - age1;
            filteredProfiles = filteredProfiles.filter(p => p.year <= g_year);
        }
        if (age2) {
            const l_year = year - age2;
            filteredProfiles = filteredProfiles.filter(p => p.year >= l_year);
        }

        setRegisterfilters(filteredProfiles);
    }

    useEffect(() => {
        getUserData();
    }, [search]); // Added search dependency to re-filter when search params change

    const updateDimensions = () => {
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
    }

    useEffect(() => {
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    });

    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [savedProfiles, setSavedProfiles] = useState(new Set());

    // MODIFIED: Use static data instead of API call
    const getLoggedInData = async () => {
        const token = localStorage.getItem("user_token");
        if (!token) {
            setIsLoggedIn(false);
            return;
        }
        try {
            setIsLoggedIn(true);

            // Simulate API delay (optional)
            await new Promise(resolve => setTimeout(resolve, 200));

            // Use static saved profiles
            setSavedProfiles(new Set(STATIC_SAVED_PROFILES));
        } catch (error) {
            console.error("Error fetching user profile:", error);
            setIsLoggedIn(false);
        }
    };

    useEffect(() => {
        getLoggedInData();
    }, []);

    const notify = () => toast("Saved Successfully!");

    // MODIFIED: Update state only (no API call)
    const savefavprofile = async (id) => {
        try {
            // Simulate API delay (optional)
            await new Promise(resolve => setTimeout(resolve, 200));

            setSavedProfiles(prev => new Set([...prev, id]));
            notify();

            console.log("Profile saved:", id); // For debugging
        } catch (error) {
            console.error("Error saving profile:", error);
        }
    };

    // NEW FUNCTION: Handle agent selection
    const handleSelectAgent = (agent) => {
        const agentData = {
            value: `${agent.userid} - ${agent.mname}`,
            label: `${agent.userid} - ${agent.mname}`,
            id: agent._id
        };

        // Navigate back with agent data in state
        navigate('/req-horoscope', { state: { selectedAgent: agentData } });
    };

    return (
        <>
            <div className="container">
                <div className="text-center" style={{ marginTop: '20px', marginBottom: '80px' }}>
                    <div className="row" style={width <= 774 ? { height: 'auto' } : { height: 'auto' }}>
                        <h2 className="font-great-vibes" style={{ margin: '0px 20px', color: '#B21919' }}>
                            Agents List
                        </h2>
                        <div style={{ margin: "1em 0", textAlign: "right" }}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => window.history.back()}
                                style={{
                                    padding: "14px",
                                    fontSize: "1.4rem",
                                    fontWeight: "bold",
                                    borderRadius: "6px",
                                    background: "#B21919",
                                    color: "#FFFFFF",
                                }}
                            >
                                &larr; Req Horoscope
                            </Button>
                        </div>

                        {registerfilter?.length ? registerfilter.map(post => (
                            <div key={post._id} className="col-md-12 search-result" style={{ marginTop: '35px', background: "#FFECD6" }}>
                                <div className="title row">
                                    <div className="col-md-6" style={{ paddingLeft: 'unset', fontSize: '15px' }}>
                                        <p className='name' style={{ fontSize: "16px" }}>
                                            {post.userid} <span style={{ fontSize: "18px" }}> - {post.mname}</span>
                                        </p>
                                    </div>
                                    <div className="col-md-6" style={{ paddingRight: 'unset', fontSize: '17px' }}>
                                        <button
                                            onClick={() => handleSelectAgent(post)}
                                            className='buttonsss'
                                            style={{ cursor: 'pointer' }}
                                        >
                                            Select Agent
                                        </button>
                                        {/* <button
                                            onClick={() => savefavprofile(post._id)}
                                            className='drink'
                                            disabled={savedProfiles.has(post._id)}
                                        >
                                            {savedProfiles.has(post._id) ? 'Saved' : 'Save Profile'}
                                            <FavoriteIcon style={{ fontSize: '14px', margin: "0px 0px 0px 8px" }} />
                                        </button> */}
                                    </div>
                                </div>

                                <hr style={{ marginTop: '-10.1px' }} />

                                <div className="row">
                                    <div className="col-md-2">
                                        <img
                                            src={post.photopath.length && post.photopath[0]
                                                ? config.API + "/images/user/" + post.photopath[0]
                                                : post.sex === "Male"
                                                    ? require('../../assests/images/man.png')
                                                    : require('../../assests/images/woman.png')}
                                            alt="Profile"
                                            className="img-responsive"
                                            style={{ height: "150px" }}
                                        />
                                    </div>

                                    <div className="col-md-5 content" style={{ alignContent: "center" }}>
                                        <table className='Droid Sans' style={{ width: '80%', fontSize: '15px', fontFamily: 'fantasy' }}>
                                            <tbody>
                                                <tr>
                                                    <td style={{ color: '#B21919', textAlign: 'left', paddingBottom: "10px" }}><b>Gender </b></td>
                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                    <td className='treatzz' style={{ textAlign: 'left', paddingBottom: "10px" }}> {post.sex}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ color: '#B21919', textAlign: 'left', paddingBottom: "10px" }}><b>Age</b></td>
                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                    <td className='treatzz' style={{ textAlign: 'left', paddingBottom: "10px" }}>
                                                        {calculateAge(post.dob)} Yrs
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ color: '#B21919', textAlign: 'left', paddingBottom: "10px" }}><b>Date of birth</b></td>
                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                    <td className='treatzz' style={{ textAlign: 'left', paddingBottom: "10px" }}>
                                                        {post.date}-{post.month}-{post.year}
                                                    </td>
                                                </tr>
                                                {/* <tr>
                                                    <td style={{ color: '#B21919', textAlign: 'left', paddingBottom: "10px" }}><b>Caste</b></td>
                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                    <td className='treatzz' style={{ textAlign: 'left', paddingBottom: "10px" }}>{post.castename}</td>
                                                </tr> */}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="col-md-5 content" style={{ alignContent: "center" }}>
                                        <table style={{ width: '80%', fontSize: '15px' }}>
                                            <tbody>
                                                <tr>
                                                    <td style={{ color: '#B21919', textAlign: 'left', paddingBottom: "10px" }}><b>City</b></td>
                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                    <td className='treatzz' style={{ textAlign: 'left', paddingBottom: "10px" }}>{post.city}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ color: '#B21919', textAlign: 'left', paddingBottom: "10px" }}><b>Email</b></td>
                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                    <td className='treatzz' style={{ textAlign: 'left', paddingBottom: "10px" }}>{post.email}</td>
                                                </tr>
                                                {/* <tr>
                                                    <td style={{ color: '#B21919', textAlign: 'left', paddingBottom: "10px" }}><b>Sub Caste </b></td>
                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                    <td className='treatzz' style={{ textAlign: 'left', paddingBottom: "10px" }}>{post.subcaste}</td>
                                                </tr> */}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        )) :
                            <div className="empty-state__content">
                                <div className="empty-state__icon">
                                    <img src={require('../../assests/img/norec.png')} alt="" />
                                </div>
                                <div className="empty-state__message">No Profiles Found.</div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default AgentsList;
